import React, { useState } from "react";
import { motion } from "framer-motion";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => setIsOpen(!isOpen);
  const handleLinkClick = () => setIsOpen(false); // Ferme le menu après un clic sur un lien

  return (
    <nav className="navbar navbar-expand-lg white-bg shadow fixed-top">
      <div className="container">
        <a className="navbar-brand fs-3 fw-bold blue-color" href="#home">
          Baba Thiam.
        </a>
        <button
          className="navbar-toggler border-0"
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={isOpen ? "true" : "false"}
          aria-label="Toggle navigation"
        >
          <motion.div className={`hamburger ${isOpen ? "is-active" : ""}`}>
            <span className="line line-1"></span>
            <span className="line line-2"></span>
            <span className="line line-3"></span>
          </motion.div>
        </button>
        <div
          className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto">
            {["Services", "A propos", "FAQ"].map((item, index) => (
              <li key={index} className="nav-item me-5">
                <a
                  className="nav-link fs-5"
                  href={`#${item.toLowerCase()}`}
                  onClick={handleLinkClick}
                >
                  {item}
                </a>
              </li>
            ))}
            <li className="nav-item">
              <motion.button
                className="btn btn-primary rounded-pill px-4 py-2"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <a
                  target="blank"
                  className="text-decoration-none white-color"
                  href="https://tally.so/r/m6vN5o"
                  onClick={handleLinkClick}
                >
                  Contactez-moi
                </a>
              </motion.button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
